import classNames from "classnames"

import { ComponentPropsWithout, RemovedProps } from "../component-props"
import { FontWeightProps } from "../props/weight.props"

import "./heading.css"

const HEADING_NAME = "SuiHeading"

const headingSizes = [1, 2, 3, 4, 5] as const

type HeadingSize = (typeof headingSizes)[number]

interface CommonHeadingProps extends FontWeightProps {
  size: HeadingSize
}

type HeadingProps = CommonHeadingProps &
  ComponentPropsWithout<"h1", RemovedProps>

const Heading = ({
  children,
  className,
  size,
  weight,
  ...headingProps
}: HeadingProps) => {
  return (
    <h1
      className={classNames(
        HEADING_NAME,
        size ? `size-${size}` : undefined,
        weight ? `sui-font-weight-${weight}` : undefined,
        className
      )}
      sx={{
        m: 0,
      }}
      {...headingProps}
    >
      {children}
    </h1>
  )
}
Heading.displayName = HEADING_NAME

export { Heading, headingSizes }
export type { HeadingProps }
